// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import constants from "@store/constants";

export const getBlogHomeDataView = (state: ApplicationState) => {
    const currentPage = getCurrentPage(state);

    return getDataView(state.data.pages, { parentNodeId: currentPage.nodeId });
};

export const getBlogHomeMostRecentDataView = (
    state: ApplicationState,
    nodeId: string,
    quantity: number,
    cacheInvalidationId?: string,
) => {
    return getDataView(state.data.pages, {
        nodeId,
        quantity,
        type: constants.blog.getDataViewType.mostRecent,
        cacheInvalidationId,
    });
};
